module.exports = __webpack_public_path__ + "static/media/bloodthurst.688a5028.png";